<section class="questions-section">
    <h2 class="questions-title">
        {{'PYMES.PREGUNTAS-FREQUENTES.TITLE' | translate }}
    </h2>

    <div class="questions-table">
        <div class="questions-row" *ngFor="let row of questionRows; let i = index; trackBy: trackByRow">
            <div class="question-item">
                <div class="question-header">
                    <div class="question-number">
                        {{ row.left.number }}
                    </div>

                    <div class="question-title-text">
                        {{ row.left.title }}
                    </div>
                </div>

                <div class="question-body" *ngIf="row.left.description || row.left.bullets?.length">
                    <div class="question-body-spacer"></div>

                    <div class="question-body-content">
                        <div class="question-description" *ngIf="row.left.description"
                            [innerHTML]="row.left.description">
                            <!-- {{ row.left.description }} -->
                        </div>

                        <ul class="question-list" *ngIf="row.left.bullets?.length">
                            <li *ngFor="let bullet of row.left.bullets" [innerHTML]="bullet"></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="question-item" *ngIf="row.right">
                <div class="question-header">
                    <div class="question-number">
                        {{ row.right.number }}
                    </div>

                    <div class="question-title-text">
                        {{ row.right.title }}
                    </div>
                </div>

                <div class="question-body" *ngIf="row.right.description || row.right.bullets?.length">
                    <div class="question-body-spacer"></div>

                    <div class="question-body-content">
                        <div class="question-description" *ngIf="row.right.description"
                            [innerHTML]="row.right.description">
                            <!-- {{ row.right.description }} -->
                        </div>

                        <ul class="question-list" *ngIf="row.right.bullets?.length">
                            <li *ngFor="let bullet of row.right.bullets" [innerHTML]="bullet"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>